import { createContext, useContext } from 'react';
import type * as signalR from '@microsoft/signalr';

export interface SignalRContextType {
    ProgressConnection: signalR.HubConnection | null;
}

export const SignalRContext = createContext<SignalRContextType | undefined>(undefined);

export const useSignalR = (): SignalRContextType => {
    const context = useContext(SignalRContext);
    if (!context) {
        throw new Error('useSignalR must be used within a SignalRProvider');
    }
    return context;
};
